import { remToPx } from '@work4all/data/lib/hooks/useRemToPx';

export const calculateListWrapperHeight = (
  total: number,
  maxItems: number,
  listItemHeight: number
) => {
  const parent = document.querySelector(
    '.key-navigation-handler-container'
  ) as HTMLElement | null;

  let totalHeight = 0;

  // Get total height of all direct children of the parent element
  // except the picker list wrapper
  Array.from(parent?.children ?? []).forEach((child) => {
    if (!child.classList.contains('picker-list-wrapper')) {
      totalHeight += (child as HTMLElement).offsetHeight;
    }
  });

  // MUI Popover height
  const popover = document.querySelector(
    '.navigation-popover-paper'
  ) as HTMLElement | null;
  const defaultPopoverHeight = window.innerHeight - 32; // 2x16px - default MUI popover Y paddings
  const popoverHeight = Math.max(popover?.offsetHeight, defaultPopoverHeight);

  // Breadcrumbs height (standalone element)
  const breadcrumbs = document.querySelector(
    '.breadcrumbs-container'
  ) as HTMLElement | null;
  const breadcrumbsHeight = breadcrumbs?.offsetHeight ?? 0;

  // Resulting list original height
  const resultingHeight = Math.min(total, maxItems);
  const resultingListHeight =
    listItemHeight * resultingHeight + (total > maxItems ? 0 : remToPx(0.25));

  const pickerListHeight =
    popoverHeight - breadcrumbsHeight - totalHeight - remToPx(1);

  // No results info row
  if (total === 0) {
    return listItemHeight + remToPx(0.5);
  }

  return pickerListHeight < resultingListHeight
    ? pickerListHeight
    : resultingListHeight;
};
